
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosPrazoDeVencimento {
    filtro?: string
    exercicio?: number
    referencia?: number

    limpar(): void {
        this.filtro = undefined
        this.exercicio = undefined
        this.referencia = undefined
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.filtro)
            data.append("filtro", this.filtro)
        if (this.exercicio)
            data.append("exercicio", String(this.exercicio))
        if (this.referencia !== undefined && this.referencia !== null)
            data.append("referencia", String(this.referencia))
        return data
    }
}